import type {
  MultipleAvailableOpportunity,
  SingleAvailableOpportunity
} from '@ps/isp-web-services-types';
import { useFormState } from 'react-final-form';
import { useSelector } from 'react-redux';

import { getAvailableSingleOpportunities } from '@swf/core/models/sports/betSlip/utils/getAvailableOpportunities';
import { select } from '@swf/core/store';

import type { FormData } from '../types';

import useOddsChanges from './useOddsChanges';

const useDisplayPriceChanges = () => {
  const { values } = useFormState<FormData>({ subscription: { values: true } });
  const singles = useSelector(select.betSlip.singleOpportunities);
  const { haveOddsChanged } = useOddsChanges();
  const hasAutoAcceptEnabled = useSelector(select.account.hasAutoAcceptEnabled);
  const isAuthenticated = useSelector(select.session.isAuthenticated);

  const containsSingleWithNoPrice = getAvailableSingleOpportunities(singles).some(
    (single) => !single.winRunnerOdds
  );
  const containsSingleWithStartingPrice = singles
    .map((single) => values[single.id])
    .some((value) => value && value.startingPriceSelected);

  return {
    displayFooterPriceChanges:
      haveOddsChanged &&
      isAuthenticated &&
      !hasAutoAcceptEnabled &&
      !containsSingleWithNoPrice &&
      !containsSingleWithStartingPrice,
    displayOpportunityPriceChanges: (
      opportunity: SingleAvailableOpportunity | MultipleAvailableOpportunity,
      predicate: () => boolean
    ) => !hasAutoAcceptEnabled && opportunity.numberOfLines === 1 && predicate()
  };
};

export default useDisplayPriceChanges;
